export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20soft%20golden%20warm%20light%20streaks%20and%20deep%20shadow%20texture%2C%20atmospheric%20movie%20theater%20vibe%20with%20subtle%20film%20grain%2C%20elegant%20theatrical%20ambiance%2C%20no%20text%2C%20dark%20moody%20tones%20with%20amber%20highlights&width=1600&height=900&seq=hero-bg-777&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <i className="ri-fire-line text-accent-500 text-sm"></i>
              <span className="text-xs font-medium text-accent-400 whitespace-nowrap">今日更新 58 部</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-5">
              777影院
              <span className="block text-accent-500 mt-1">高清免费影视平台</span>
            </h1>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              777影院汇聚海量电影、电视剧、综艺、动漫资源，每日同步更新热门剧集。超清画质搭配极速播放引擎，全程无广告打扰，打开即看，畅享纯净观影体验。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              覆盖国产剧、韩剧、美剧、日剧及院线大片，支持多线路切换，无论手机还是电脑都能流畅观影。当前热播《庆余年2》《唐朝诡事录之西行》《墨雨云间》全集已上线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">12万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-8 bg-foreground-800/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">4K</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质</div>
              </div>
              <div className="w-px h-8 bg-foreground-800/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">0</div>
                <div className="text-xs text-foreground-500 mt-1">全程无广告</div>
              </div>
              <div className="w-px h-8 bg-foreground-800/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">日更</div>
                <div className="text-xs text-foreground-500 mt-1">同步追剧</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full transition-all text-sm cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-700/40 hover:border-accent-500/60 text-foreground-200 hover:text-accent-400 font-medium rounded-full transition-all text-sm cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3 md:gap-4">
                <div className="space-y-3 md:space-y-4">
                  <div className="rounded-xl overflow-hidden bg-background-800/60 border border-background-700/30">
                    <img
                      src="https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20movie%20poster%20style%2C%20elegant%20traditional%20costume%20characters%20in%20dramatic%20lighting%2C%20cinematic%20composition%20with%20warm%20amber%20tones%2C%20dark%20moody%20background%2C%20film%20poster%20aesthetic%2C%20mysterious%20atmosphere&width=600&height=850&seq=hero-poster-1&orientation=portrait"
                      alt="热门古装剧"
                      className="w-full aspect-[2/3] object-cover object-top"
                      loading="eager"
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden bg-background-800/60 border border-background-700/30">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20crime%20thriller%20drama%20poster%20style%2C%20intense%20expression%20characters%20in%20dark%20urban%20setting%2C%20cinematic%20lighting%20with%20warm%20and%20cool%20contrast%2C%20film%20poster%20aesthetic%2C%20suspenseful%20atmosphere&width=600&height=850&seq=hero-poster-2&orientation=portrait"
                      alt="热门悬疑剧"
                      className="w-full aspect-[2/3] object-cover object-top"
                      loading="eager"
                    />
                  </div>
                </div>
                <div className="space-y-3 md:space-y-4 pt-8">
                  <div className="rounded-xl overflow-hidden bg-background-800/60 border border-background-700/30">
                    <img
                      src="https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20drama%20poster%20style%2C%20ethereal%20characters%20in%20flowing%20costumes%20with%20magical%20elements%2C%20cinematic%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20film%20poster%20aesthetic&width=600&height=850&seq=hero-poster-3&orientation=portrait"
                      alt="热门仙侠剧"
                      className="w-full aspect-[2/3] object-cover object-top"
                      loading="eager"
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden bg-background-800/60 border border-background-700/30">
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20drama%20style%20poster%2C%20emotional%20characters%20in%20soft%20romantic%20lighting%2C%20cinematic%20composition%20with%20warm%20tones%2C%20contemporary%20setting%2C%20film%20poster%20aesthetic%2C%20melancholy%20mood&width=600&height=850&seq=hero-poster-4&orientation=portrait"
                      alt="热门韩剧"
                      className="w-full aspect-[2/3] object-cover object-top"
                      loading="eager"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}